import script from "./DynamicForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicForm.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicForm.vue?vue&type=style&index=0&id=89b6c38e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b6c38e"]])

export default __exports__